import { Component, OnInit, OnDestroy, Type, Input, ViewChild, ViewContainerRef,  ComponentFactoryResolver, Renderer, ComponentRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';


@Component({
  selector: 'ps-dynamic',
  template: /*html*/`
    <ng-container #viewport></ng-container>
  `
})
export class DynamicComponent implements OnInit, OnDestroy {

  @Input() component: Type<any>;
  @Input() context: Observable<any>;

  @ViewChild('viewport', { read: ViewContainerRef, static: true }) _viewport: ViewContainerRef;

  private _subscription: Subscription;
  private _componentRef: ComponentRef<any>;

  constructor(private _cfr: ComponentFactoryResolver, private _renderer: Renderer) { }

  ngOnInit() {

    const componentFactory = this._cfr.resolveComponentFactory(this.component);
    this._componentRef = this._viewport.createComponent(componentFactory, this._viewport.length, this._viewport.parentInjector, []); 

    // subscribe for eventual data.
    this._subscription = this.context.subscribe(
      newContext => this._refreshInputs(newContext)
    );
  }

  private _refreshInputs(newContext: Object) : void {
    for(var key in newContext) {
      if (newContext.hasOwnProperty(key))
        this._componentRef.instance[key] = newContext[key];
    }
  }

  ngOnDestroy() {
    if (this._subscription)
      this._subscription.unsubscribe();
  }
}
